if (!customElements.get('orlivy-size-guide')) {
  customElements.define('orlivy-size-guide', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      const template = this.querySelector('template')?.content;
      if (!template) return;
      let source = template.querySelector('[data-size-chart], .orlivy-size-chart, .nola-product-size-guide');
      if (!source?.matches('table') && !source?.querySelector('table')) {
        source = Array.from(template.querySelectorAll('table')).find(table =>
          Array.from(table.rows[0]?.cells || []).some(cell => /\btallas?\b/i.test(cell.textContent))
        );
      }
      if (!source) return;
      this.ready = true;
      const trigger = this.querySelector('.olv-size-guide__trigger');
      const dialog = this.querySelector('dialog');
      const content = this.querySelector('.olv-size-guide__content');
      const close = this.querySelector('.olv-size-guide__close');
      trigger.addEventListener('click', () => {
        if (!content.childElementCount) {
          const copy = source.cloneNode(true);
          copy.removeAttribute('id');
          copy.querySelectorAll('[id]').forEach(el => el.removeAttribute('id'));
          copy.querySelectorAll('script, style, iframe').forEach(el => el.remove());
          copy.querySelectorAll('[style]').forEach(el => el.removeAttribute('style'));
          content.append(copy);
        }
        dialog.showModal();
        close.focus({ preventScroll: true });
      });
      close.addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const r = dialog.getBoundingClientRect();
        if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close();
      });
      dialog.addEventListener('close', () => trigger.focus({ preventScroll: true }));
      this.hidden = false;
    }
  });
}
